module.exports = __webpack_public_path__ + "static/LobbySketch-d7e119cfb776b5132035df0a42eda260.png";